<template>
<div>
  <div style="display:flex">
    <vs-select
      label="출제연도"
      v-model="selectedYear">
    <vs-select-item
        v-for="(item , index) in dateList"
        :key="index"
        :value="item.value"
        :text="item.text" />
    </vs-select>
  </div>
  <div style="display:flex; justify-content:space-between">
    <vx-card style="width:49%; margin:20px 0;">
      <div style="display:flex; justify-content:space-between; margin-bottom:15px;">
        <div slot="header" style="margin-bottom:10px; font-weight:bold;">시험 일정</div>
        <vs-button style="width:35px; height:30px; margin-right:5px; font-size:25px; padding:0;" @click="openPopUp()">+</vs-button>
      </div>
        <div class="vx-row" style="max-height:200px; overflow-y:scroll; padding:10px 20px;">
          <ExamList style="width:100%"
                    @getList="getWeekList(exam , index)"
                    @open="openPop"
                    @remove="deleteDateList"
                    v-for="(exam, index) in examId"
                    :examInfo="exam" :key="index"
                    :examId="exam"/>
          <p style="text-align:center" v-if="examId.length == 0"> 출제 내역이 없습니다.</p>
        </div>
    </vx-card>
    <transition name='fade' appear>
      <vx-card v-if="activeDisplay" style="width:49%; margin:20px 0; padding:0 10px">
        <div style="display:flex; justify-content:space-between; text-align:center;">
          <div style="margin-bottom:10px"><span style="font-size:14px; font-weight:bold">{{selectPlan.month_week}}</span> 예정 리스트</div>
        </div>
        <div style="max-height:405px;">
          <NextExamList style="width:100%" v-for="(list , index) in weekList" @delete="deleteExamList" :examInfo="list" :key="index" />
          <p style="text-align:center; color:#ddd; margin:60px 0" v-if="weekList.length == 0">예정시험이 없습니다. <br> 시험을 추가해주세요!</p>
        </div>
      </vx-card>
    </transition>
  </div>
  <div class="setGrade" style=" display:flex; margin-bottom: 30px;">
    <div style="margin-right:5px;">
      <vs-select
        label="학년별"
        v-model="selected">
        <vs-select-item
          v-for="(item , index) in gradeList"
          :key="index"
          :value="item.value"
          :text="item.text" />
      </vs-select>
    </div>
  </div>
  <div style="display:flex; justify-content:space-between; margin-top:30px;">
    <vx-card class="box_wrap" style="margin-bottom:20px; width:50%">
      <div>
        <div>
          <div slot="header" style="margin-bottom:10px; font-weight:bold;">전체 시험 리스트</div>
          <!-- && exam.exam_date_id == examId.id -->
          <div class="vx-row" style="padding:10px; max-height:500px; overflow:auto">
            <ExamItem @set="selectSubject"
                      @show="showExamInfo"
                      v-if="selected == 12 && exam.info == 'sat' && exam.admin_check >= 1"
                      v-for="(exam, index) in allExamList" :key="index" :examInfo="exam"/>
            <ExamItem @set="selectSubject"
                      @show="showExamInfo"
                      v-if="selected == 11" v-for="(exam, index) in schoolInfo.second"
                      :examInfo="exam" :key="index" />
            <ExamItem @set="selectSubject"
                      @show="showExamInfo"
                      v-if="selected == 10"
                      v-for="(exam, index) in schoolInfo.first"
                      :examInfo="exam" :key="index" />
          </div>
        </div>
      </div>
    </vx-card>
    <div class="box_wrap">
      <transition name="fade" >
        <vx-card v-if="subjectBox" style="width:100%; margin-bottom:20px;">
          <div style="display:flex; margin-bottom:10px; justify-content:space-between;">
            <p style="font-weight:bold">{{selectExam.test_name}}</p>
            <p>총 과목 수 : {{subjectList.length}}</p>
          </div>
          <div style="max-height:500px; overflow:auto">
            <div style="margin-top:20px;">
              <div>
                <div style="display:flex; justify-content:space-between; font-weight:bold; color:#1D9CD3; border-bottom:1px solid #ddd; padding:10px; margin-bottom:40px;">
                  <p>주요과목</p>
                  <p>{{main_list.length}}</p>
                </div>
                <div v-for="(subject , index) in main_list" :key="index" style="text-align:center; font-size:15px; font-weight:bold">
                  {{subject.subject}} / 총점 : {{subject.total_score}}
                </div>
                <p v-if="main_list.length == 0" style="text-align:center; margin:20px 0; color:#ddd;">입력된 과목이 없습니다</p>
              </div>
              <div>
                <div style="display:flex; justify-content:space-between; font-weight:bold; color:#1D9CD3; border-bottom:1px solid #ddd; padding:10px; margin:40px 0;">
                  <p>탐구과목</p>
                  <p>{{society_list.length}}</p>
                </div>

                <div v-for="(subject , index) in society_list" :key="index" style="text-align:center; font-size:15px; font-weight:bold">
                  {{subject.subject}} / 총점 : {{subject.total_score}}
                </div>
                <p v-if="society_list.length == 0" style="text-align:center; margin:20px 0; color:#ddd;">입력된 과목이 없습니다</p>
              </div>
              <div>
                <div style="display:flex; justify-content:space-between; font-weight:bold; color:#1D9CD3; border-bottom:1px solid #ddd; padding:10px; margin:40px 0;">
                  <p>시험이 추가된 일정</p>
                  <p>{{plannedList.length}}</p>
                </div>
                <p v-for="(item,index) in plannedList" :key="index" style="text-align:center; font-weight:bold">
                  {{item.month_week}}
                </p>
              </div>
            </div>
          </div>
        </vx-card>
      </transition>
    </div>
    <vs-popup :title="selectExam.test_name" :active.sync="popupActive">
      <div class="mt-4">
        <label class="text-sm">시험 시작 날짜</label>
        <flat-pickr class="w-full" placeholder="시작일" v-model="start_time"/>
      </div>
      <div class="mt-4">
        <label class="text-sm">시험 종료 날짜</label>
        <flat-pickr class="w-full" placeholder="종료일" v-model="end_time"/>
      </div>
      <vs-button @click="summitUpdateInfo()" style="float:right; margin-top:20px;">SUMMIT</vs-button>
    </vs-popup>
  </div>
</div>
</template>

<script>
import { PlusIcon } from 'vue-feather-icons'
import ExamItem from './ExamItem.vue'
import ExamList from './ExamList.vue'
import NextExamList from './NextExamList.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    'ExamList' : ExamList,
    'ExamItem':ExamItem,
    'NextExamList' : NextExamList,
    PlusIcon,
    flatPickr
  },
  data() {
    return {
      start_time: '',
      end_time: '',
      activeDisplay: false,
      popupActive:false,
      selected: 12,
      gradeList: [
        {text:'수능' , value: '12'},
        {text:'고2' , value: '11'},
        {text:'고1' , value: '10'},
      ],
      selectedYear: 2022,
      dateList: [],
      subjectBox: false,
      selectExam: {},
      changedPlan: {},
      selectPlan: {},
      main_list: {},
      society_list: {},
      plannedList: [],
      selectPlanIndex: null
    }
  },
  created() {
    var year = Number(this.$moment(new Date()).format('YYYY'))
    this.selectedYear = year
    for(var i=year + 1; i>2019; i--) {
      this.dateList.push({
        text: i,
        value: Number(i)
      })
    }
    this.$store.dispatch('etest/getEtestExam', 'admin').then(()=> {
      this.getExamPlanList()
    })
  },
  watch: {
    subjectList() {
      var subject = JSON.parse(JSON.stringify(this.subjectList))
      this.main_list = []
      this.society_list = []
      for(var i in subject) {
        if(subject[i].subject_type_id != 9) {
            this.main_list.push(subject[i])
              this.main_list = this.main_list.sort((a , b) => {
              return a.subject < b.subject ? -1 : a.subject > b.subject? 1 : 0;
            })
          } else {
              this.society_list.push(subject[i])
                this.society_list = this.society_list.sort((a , b) => {
                return a.subject < b.subject ? -1 : a.subject > b.subject? 1 : 0;
              })
          }
      }
    },
    selectedYear() {
      this.$store.dispatch('etest/getExamDateId' , this.selectedYear)
    },
    exam_end_time() {
      if(this.exam_start_time != '') {
        this.activeDisplay = "block"
      }
    },
    selected() {
        this.selectExam = {}
        this.subjectBox = false
    },
    popupActive() {
      if(!this.popupActive) {
        console.log(this.changedPlan)
        this.changedPlan = {}
      }
    }
  },
  computed: {
    examId() {
      return this.$store.state.etest.examId
    },
    schoolInfo() {
      return this.$store.state.etest.schoolInfo
    },
    allExamList() {
      return this.$store.state.etest.allExamList
    },
    plannedExamList() {
      return this.$store.state.etest.plannedExamList
    },
    subjectList() {
      return  this.$store.state.etest.subjectList
    },
    weekList() {
      return  this.$store.state.etest.weekList
    }
  },
  methods: {
    checkPlanedCount(val) {
      this.plannedList = []
        for(var i in this.examId) {
          var index = this.examId[i].exam_info_list.findIndex((item)=> {
            return item.exam_id == val.id
          })
          if(index != -1) {
            this.plannedList.push(this.examId[i])
          }
        }
        console.log(this.plannedList)
    },
    getExamPlanList() {
      this.$store.dispatch('etest/getExamDateId' , this.selectedYear)
    },
    deleteExamList(val) {
        this.$store.dispatch('etest/deleteExamInfo' , val.id).then(()=> {
          this.$store.dispatch('etest/getExamDateId' , this.selectedYear).then(()=> {
            this.$store.dispatch('etest/getSelectWeekInfo' , this.selectPlan.id).then(()=> {
            this.$vs.notify({
                  title: '완료',
                  text: '시험이 삭제되었습니다.',
                  iconPack: 'feather',
                  color: 'red'
                })
          })
          })
        })
    },
    deleteDateList(val) {
      this.$store.dispatch('etest/deletePlanDate' , val.id).then(()=> {
        this.getExamPlanList()
        this.$vs.notify({
              title: '완료',
              text: '시험일정이 삭제되었습니다.',
              iconPack: 'feather',
              color: 'red'
            })
      })
    },
    getWeekList(val , index) {
      this.$store.dispatch('etest/getSelectWeekInfo' , val.id).then(()=> {
        this.activeDisplay = true
        this.selectPlan = val
        this.selectPlanIndex = this.examId.length - index
      })
    },
    openPop(val) {
      this.changedPlan = val
      this.popupActive = true
    },
    summitUpdateInfo() {
      if(this.changedPlan.state == 1) {
        this.$store.dispatch('etest/changePlanDate' , {
          id: this.changedPlan.info.id,
          start_date: this.start_time,
          end_date: this.end_time
        }).then(()=> {
          this.getExamPlanList()
          this.$vs.notify({
                title: '완료',
                text: '시험일정이 변경되었습니다.',
                iconPack: 'feather',
                icon: 'icon check_box',
                color: 'warning'
              })
        })
      } else {
        this.$store.dispatch('etest/setWeekInfo' , {
          start_date: this.start_time,
          end_date: this.end_time
        }).then(()=> {
          this.getExamPlanList()
          this.$vs.notify({
                title: '완료',
                text: '시험일정이 추가되었습니다.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
        })
        this.changedPlan = {}
      }
      this.popupActive = false
    },
    openPopUp() {
      this.popupActive = true
      this.$store.commit('etest/SET_EXAM_TIME_EDITOR' , true)
    },
    showExamInfo(val) {
      this.subjectBox = true
      this.selectExam = val
      this.checkPlanedCount(this.selectExam)
      this.$store.dispatch('etest/getEtestSubject', val.id).then(()=> {
        console.log(this.subjectList)
      })
    },
    selectSubject(val) {
      if(this.activeDisplay) {
        var index = this.weekList.findIndex((item)=> {
          return item.exam_id == val.id
        })
        if(index != -1) {
          this.$vs.notify({
                title: '에러',
                text: '이미 등록된 시험이 있습니다',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            return
        }
        if(index == -1) {
          this.$store.dispatch('etest/updateSelectExamInfo', {
            id: val.id,
            exam_date_id: this.selectPlan.id,
            grade_id: this.selected,
            round: this.selectPlanIndex,
            year: this.selectPlan.year,
          }).then(()=> {
            this.$store.dispatch('etest/getExamDateId' , this.selectedYear).then(()=> {
              this.$store.dispatch('etest/getSelectWeekInfo' , this.selectPlan.id).then(()=> {
                this.$vs.notify({
                    title: '완료',
                    text: '시험이 추가되었습니다',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                  })
              })
            })
          })
          return
        }
      } else {
        this.$vs.notify({
              title: '에러',
              text: '상단 시험일정을 먼저 선택해주세요',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
      }
    }
  }
}
</script>


<style lang="scss">
.box_wrap {
  width: 48%
}
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
</style>
